import Component from 'flarum/common/Component';

/**
 * 认证徽章：读取用户 taroWandLevel 属性，显示 C0-C4 等级徽章
 * 用法：<CertificationBadge user={user} />
 */
export default class CertificationBadge extends Component {
  view() {
    const user = this.attrs.user;
    const level = user ? (user.attribute('taroWandLevel') || 'C0') : 'C0';
    const meta = this.levelMeta(level);

    return (
      <span className={'CertificationBadge CertificationBadge--' + level} title={meta.title}>
        <i className="fas fa-certificate" /> {level}
      </span>
    );
  }

  levelMeta(level) {
    const map = {
      C0: { title: '未认证' },
      C1: { title: '初级认证' },
      C2: { title: '中级认证' },
      C3: { title: '高级认证' },
      C4: { title: '大师认证' },
    };
    return map[level] || map.C0;
  }
}
